define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/Configuration',
	'internal_util/OptionsUtil',
	'model/AuthenticationOption',
	'model/Error',
	'model/ErrorType',
	'service/EventListenerRegistry',
	'amdi18n-loader?!service/nls/OptionsManager_strings',
	'lib/jquery'
], function (
		Logger,
		Util,
		Configuration,
		OptionsUtil,
		AuthenticationOption,
		Error,
		ErrorType,
		EventListenerRegistry,
		Strings,
		jQuery
		) {
	'use strict';

	/**
	 * OptionsManager class
	 */
	return function (authFlowId) {
		let _authFlowId = authFlowId,
				_providerInfo = null,
				_authenticationOptions = null,
				_requestedAttributes = null,
				_currentAuthenticationOption = null,
				that = this;

		let pvrCtxClasses = ["SoftwarePKI",
							"SmartcardPKI"];

		// private methods

		function log(method, message, data) {
			Logger.log('OptionsManager', method, message, data);
		}

		function callLog(method, message, data, event, callbacks) {
			log(method, message, data);
			EventListenerRegistry.callListeners(event, data, function () {
				Util.callCallbacks(callbacks, data);
			});
		}

		function getRequestedAttributesXML(requestedAttributes) {
			let xml = '<?xml version="1.0" encoding="utf-8"?>' +
					'<RequestedAttributes xmlns="urn:oasis:names:tc:SAML:profile:privacy" ' +
					'xmlns:md="urn:oasis:names:tc:SAML:2.0:metadata">',
					i;

			if (requestedAttributes.length > 0) {
				for (i = 0; i < requestedAttributes.length; i++) {
					xml += '<md:RequestedAttribute Name="' + requestedAttributes[i].name() + '" ' +
							'isRequired="' + requestedAttributes[i].isRequired() + '"></md:RequestedAttribute>';
				}
			}

			xml += '</RequestedAttributes>';

			return xml;
		}


		// public methods

		this.providerInfo = function () {
			return _providerInfo;
		};

		this.authenticationOptions = function () {
			return _authenticationOptions;
		};
                
                this.getAuthenticationOptionById = function (id) {
                    for (let i in _authenticationOptions) {
                        if (_authenticationOptions[i].id() === id) {
                            return _authenticationOptions[i];
                        }
                    }
                    return null;
		};

		this.requestedAttributes = function () {
			return _requestedAttributes;
		};
		
		this.currentAuthenticationOption = function () {
			return _currentAuthenticationOption;
		};
		
		this.currentAuthnContextClassRef = function () {
			if (_currentAuthenticationOption instanceof AuthenticationOption) {
				return _currentAuthenticationOption.authnContextClassRef();
			}
			return _currentAuthenticationOption.authenticationOptions()[0].authnContextClassRef();
		};
		
		this.authnContextClassRefForOption = function (authenticationOption) {
			if (authenticationOption instanceof AuthenticationOption) {
				return authenticationOption.authnContextClassRef();
			}
			return authenticationOption.authenticationOptions()[0].authnContextClassRef();
		};
		
		this.usePVR = function() {
			let authContext = that.currentAuthnContextClassRef();
			
			for (let ctx in pvrCtxClasses) {
				if (authContext.indexOf(pvrCtxClasses[ctx]) >= 0)
					return true;
			}
			
			return false;
		};
		
		this.usePVRforOption = function(authenticationOption) {
			let authContext = that.authnContextClassRefForOption(authenticationOption);
			
			for (let ctx in pvrCtxClasses) {
				if (authContext.indexOf(pvrCtxClasses[ctx]) >= 0)
					return true;
			}
			
			return false;
		};

		this.getOptions = function (callbacks, errorCallbacks) {
			let _name = 'getOptions',
					optionsURL = Configuration.get('OPTIONS_URL') + '?flow-id=' + _authFlowId;

			callLog(_name, Strings.get_options_started, optionsURL, 'GET_OPTIONS_STARTED', function () {
				jQuery.ajax({
					url: optionsURL,
					dataType: 'xml',
					success: function (options) {
						try {
							options = OptionsUtil.parseOptions(options);
							_providerInfo = options['providerInfo'];
							_authenticationOptions = options['authenticationOptions'];
							_requestedAttributes = options['requestedAttributes'];
						} catch (error) {
							error = new Error(ErrorType.NON_RECOVERABLE, Strings.get_options_failed, error.message);
							callLog(_name, Strings.get_options_failed, error, 'GET_OPTIONS_FAILED', errorCallbacks);
							return;
						}
						
						OptionsUtil.loadImages(options, function () {
							callLog(_name, Strings.get_options_succeeded, options, 'GET_OPTIONS_SUCCEEDED', callbacks);
						}, function (error) {
							callLog(_name, Strings.get_options_failed, error, 'GET_OPTIONS_FAILED', errorCallbacks);
						});
					},
					error: function (jqXHR) {
						let error;

						if (jqXHR.status === 404) {
							error = new Error(ErrorType.NON_RECOVERABLE, Strings.get_options_failed, Strings.session_expired, true);
						} else {
							error = new Error(ErrorType.NON_RECOVERABLE, Strings.get_options_failed, Util.toString(jqXHR));
						}

						callLog(_name, Strings.get_options_failed, error, 'GET_OPTIONS_FAILED', errorCallbacks);
					}
				});
			});
		};
		
		this.finish = function(callbacks, errorCallbacks) {
			let _name = 'finish',
				finishUrl = Configuration.get('OPTIONS_URL') + '/finish?flow-id=' + _authFlowId;

			callLog(_name, Strings.finish_authentication, finishUrl, 'FINISH_AUTH_STARTED', function () {
				jQuery.ajax({
					url: finishUrl,
					dataType: 'json',
					success: function (brokerFinishResponse) {
						callLog(_name, Strings.finish_authentication_succeeded, brokerFinishResponse, 'FINISH_AUTH_SUCCEEDED', callbacks);
					},
					error: function (jqXHR) {
						let error;

						if (jqXHR.status === 404) {
							error = new Error(ErrorType.NON_RECOVERABLE, Strings.finish_authentication_failed, Strings.session_expired, true);
						} else {
							error = new Error(ErrorType.NON_RECOVERABLE, Strings.finish_authentication_failed, Util.toString(jqXHR));
						}

						callLog(_name, Strings.finish_authentication_failed, error, 'FINISH_AUTH_FAILED', errorCallbacks);
					}
				});
			});
		};

		this.cancelSelectOption = function (callbacks, errorCallbacks) {
			let _name = 'cancelSelectOption',
					data = {
						"flow-id": _authFlowId,
						'auth-return-url': Configuration.get('IDM_FINISH_URL')
					};

			callLog(_name, Strings.cancel_select_option_started, data, 'CANCEL_SELECT_OPTION_STARTED', function () {
				jQuery.ajax({
					url: Configuration.get('CANCEL_SELECT_OPTION_URL'),
					type: 'POST',
					contentType: 'application/x-www-form-urlencoded',
					dataType: 'text',
					data: data,
					success: function (redirectURL) {
						let error;

						if (!Util.isValidURL(redirectURL)) {
							error = new Error(ErrorType.NON_RECOVERABLE, Strings.cancel_select_option_failed,
									Strings.invalid_redirect_url + redirectURL);
							callLog(_name, Strings.invalid_redirect_url, error, 'CANCEL_SELECT_OPTION_FAILED', errorCallbacks);
							return;
						}
						
						_currentAuthenticationOption = null;

						callLog(_name, Strings.cancel_select_option_succeeded, redirectURL, 'CANCEL_SELECT_OPTION_SUCCEEDED', callbacks);
					},
					error: function (jqXHR) {
						let error;

						if (jqXHR.status === 404) {
							error = new Error(ErrorType.RECOVERABLE, Strings.cancel_select_option_failed, Util.toString(jqXHR));
						} else {
							error = new Error(ErrorType.NON_RECOVERABLE, Strings.cancel_select_option_failed, Util.toString(jqXHR));
						}

						callLog(_name, Strings.cancel_select_option_failed, error, 'CANCEL_SELECT_OPTION_FAILED', errorCallbacks);
					}
				});
			});
		};	

		this.selectOption = function (authenticationOption, requestedAttributes, callbacks, errorCallbacks) {
			let _name = 'selectOption',
					data = {
						"flow-id": _authFlowId,
						'user-selection': getRequestedAttributesXML(requestedAttributes),
						'auth-return-url': Configuration.get('IDM_FINISH_URL')
					};
					
			if (authenticationOption instanceof AuthenticationOption) {
				data['option'] = authenticationOption.id();
			} else {
				data['option-group'] = authenticationOption.id();
			}

			callLog(_name, Strings.select_option_started, data, 'SELECT_OPTION_STARTED', function () {
				jQuery.ajax({
					url: Configuration.get('SELECT_OPTION_URL'),
					type: 'POST',
					contentType: 'application/x-www-form-urlencoded',
					dataType: 'text',
					data: data,
					success: function (activationURL) {
						let error;

						if (!Util.isValidURL(activationURL)) {
							error = new Error(ErrorType.NON_RECOVERABLE, Strings.select_option_failed,
									Strings.invalid_activation_url + activationURL);
							callLog(_name, Strings.invalid_activation_url, error, 'SELECT_OPTION_FAILED', errorCallbacks);
							return;
						}
						
						_currentAuthenticationOption = authenticationOption;

						callLog(_name, Strings.select_option_succeeded, activationURL, 'SELECT_OPTION_SUCCEEDED', callbacks);
					},
					error: function (jqXHR) {
						let error;

						if (jqXHR.status === 404) {
							error = new Error(ErrorType.RECOVERABLE, Strings.select_option_failed, Util.toString(jqXHR));
						} else {
							error = new Error(ErrorType.NON_RECOVERABLE, Strings.select_option_failed, Util.toString(jqXHR));
						}

						callLog(_name, Strings.select_option_failed, error, 'SELECT_OPTION_FAILED', errorCallbacks);
					}
				});
			});
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/service/OptionsManager.js
// module id = 63
// module chunks = 4